import React, { useMemo } from 'react';
import { TextButton as Button, Icon } from '@oneaudi/unified-web-components';
import { useTranslation } from 'react-i18next';
import { ContactDealerCta, CtaGroupMobileWrapper, StyledTextButton } from './ButtonGroups.styles';
import { PromotionType } from '../../../types/offers';
import { parseDigitalLeadsData } from '../../../utils/digitalLeadsFormat';

type ButtonGroupsProps = {
  offer: PromotionType;
  confirmedZipcode: string;
  inventoryUrl: string;
  dealerId?: string;
};

const ButtonGroups: React.FC<ButtonGroupsProps> = ({
  offer,
  confirmedZipcode,
  inventoryUrl,
  dealerId,
}) => {
  const { t } = useTranslation();

  const digitalLeadsInfo = useMemo(() => {
    const dataInfo = parseDigitalLeadsData(offer, confirmedZipcode, dealerId);
    return dataInfo;
  }, [confirmedZipcode, dealerId, offer]);

  const ContactUsButton = useMemo(() => {
    return (
      <ContactDealerCta
        id="digital-leads"
        data-info={digitalLeadsInfo}
        data-testid="featured-offer-details-contact-cta"
      >
        {t('promo.offers.cta.contact')}
        <Icon name="forward-active" size="s" />
      </ContactDealerCta>
    );
  }, [digitalLeadsInfo, t]);

  const ViewInventoryButton = useMemo(() => {
    return (
      <StyledTextButton
        data-testid="featured-offer-inventory-cta"
        href={inventoryUrl}
        variant="tertiary"
        size="sm"
        className="aa"
        target="_blank"
        icon="external-link"
        iconPosition="trailing"
      >
        {t('promo.offers.cta.inventory')}
      </StyledTextButton>
    );
  }, [inventoryUrl, t]);

  const renderCTAs = useMemo(() => {
    return (
      <>
        {ViewInventoryButton}
        {ContactUsButton}
      </>
    );
  }, [ContactUsButton, ViewInventoryButton]);

  return <CtaGroupMobileWrapper>{renderCTAs}</CtaGroupMobileWrapper>;
};

export default ButtonGroups;
